/*
 * Public API Surface of ng-image-fullscreen-view
 */

export * from './lib/ng-image-fullscreen-view.service';
export * from './lib/ng-image-fullscreen-view.component';
export * from './lib/ng-image-fullscreen-view.module';
